<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'App',

        data() {
            return {
                timer: null,
            }
        },

        watch: {
            '$vuetify.theme.dark'() {
                this.setRootCss();
            }
        },

        created() {
            this.timer = setInterval(() => {
                this.refreshToken();
            }, 3500 * 1000);
            this.setRootCss();
        },

        computed: {
            theme() {
                return this.$vuetify.theme.dark ? 'dark' : 'light';
            }
        },

        methods: {
            refreshToken() {
                this.$store.dispatch('application/getNewCSRFToken');
            },
            setRootCss() {
                const styles = this.$vuetify.theme.themes[this.theme];

                for (let property in styles) {
                    if (styles.hasOwnProperty(property)) {
                        document.documentElement.style.setProperty('--color-' + property, styles[property]);
                    }
                }
            }
        },

        beforeDestroy() {
            clearInterval(this.timer);
        },
    }
</script>
